module.exports = __webpack_public_path__ + "static/img/news_3.492f3b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/news_3.jpg
// module id = PPCz
// module chunks = 0